// ============================================================================
//  ENDPOINTS — EDIT AFTER DEPLOYING THE WORKER
// ----------------------------------------------------------------------------
//  NOTES_ENDPOINT is the base URL of the bvndle-notes Cloudflare Worker
//  (see ../../bvndle-notes-worker/). Until you deploy it and paste the URL
//  here, meeting notes + per-KPI weekly notes are captured in localStorage on
//  each reviewer's device (still visible in the app, just not shared). Once
//  this is set, the app writes through to the Worker so the whole ManCo sees
//  the same record and it survives a machine swap.
//
//  Deploy steps live in bvndle-notes-worker/README.md. After `wrangler deploy`
//  paste the deployed URL below, e.g.:
//    export const NOTES_ENDPOINT = "https://bvndle-notes.kabelo.workers.dev";
// ============================================================================

export const NOTES_ENDPOINT: string = "https://bvndle-notes.bvndle.workers.dev";
